import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images, uiImages } from "./images";
import { mc } from "../characters/MC";
import { V9VanessaMorning } from "./V9_VanessaMorning";
import { Insta } from "../../src/components/insta/InstaClass";
import UI from "../../src/shell/UI";
import { getInstaData } from "../helpers/InstaPostsHelpers";
import { V9AnnMorningCall } from "./V9_AnnMorningCall";
import { V9EmilyMorningPlaying } from "./V9_EmilyMorningPlaying";
import Game from "../../src/shell/Game";
import { V9MorningTextsDay1 } from "./V9_MorningCallsDay1";
import { V9VanessaBus } from "./V9_VanessaBus";
import { V9VanessaMCChrisBar } from "./V9_VanessaMCChrisBar";
import { doPhoneRing, doSmsSound, doTransition, doWaitImageByTime, isAnnCorrupted, isAnnGF, isAnnGFAndCorrupted, isDatingJenny } from "../helpers/helpers";
import { V9VanessaMCBusNight } from "./V9_VanessaMCBusNight";
import { V9EmilyMorningDay2 } from "./V9_EmilyMorningDay2";
import { V9AlexDate } from "./V9_AlexDate";
import { V9EmilyNightDayTwo } from "./V9_EmilyNightDayTwo";
import { AnnProfilePictureLogic } from "../helpers/annInstaHelpers";
import { V9AnnDormNightChris } from "./V9_AnnDormNightChris";
import { V9AnnMCNightConv } from "./V9_AnnConvNight";
import { jenny } from "../characters/Jenny";
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import { V9EmilyMorningRoomDay3 } from "./V9_EmilyMorningRoomDay3";
import { ann } from "../characters/Ann";
import { V9AnnMCMotel } from "./V9_AnnMCMotel";
import { globals } from "../characters/globals";

export const shouldShowAnnChrisDormScene = () => {
    // if Ann is GF + NOT corrupted + MC told Ann he is not ok with Chris dating her 
    return (!isAnnCorrupted() && isAnnGF()) && ((Question.globalAnswers.V8AnnDateMCOkWithChris === false));
};

export const V9Start = async (): Promise<any> => {
    AnnProfilePictureLogic();

    ImageClass.setImage(images.v2_5.BlackScreen);
    mc.think(`You are about to start playing the recent alpha content!\nPlease save your game now and load it from this point once the version is completed to avoid bugs and unwanted behavior.`);
    mc.think(`Furthermore, some scenes are missing and will be completed for the final version, along with proofreading and animations.\nIf that's important to you, please consider waiting for the final release.`);

    // disable Ann hate and joe rival after checking when it stops making sense.
    return jump(V9VanessaMorningBefore, "V9VanessaMorningBefore");
};


export const V9VanessaMorningBefore = async (): Promise<any> => {
    return jump(V9VanessaMorning, "V9VanessaMorning");
};
export const V9VanessaMorningAfter = async (): Promise<any> => {
    doWaitImageByTime(images.v9.V9Morning);
    mc.think(`What is the odd of me getting a random package the same day Vanessa orders something to my place?`);
    mc.think(`She must be trolling me.`);
    // TODO: make sure I want to make it vibrator less here, and not later open
    //So here, Vanessa will see it and say something about it, and later on it will disappear
    if (isAnnGF() && isAnnCorrupted()) {
        mc.think(`And where is the Anal vibrator anyway? Did Ann forgot to put it back?`);

    } else {

    }

    return jump(V9Events, "V9Events");
};

export const V9MorningTextsDay1Before = async (): Promise<any> => {
    return jump(V9MorningTextsDay1, "V9MorningTextsDay1");
};
export const V9MorningTextsDay1After = async (): Promise<any> => {
    return jump(V9Events, "V9Events");
};
export const V9Events = async (): Promise<any> => {
    AnnProfilePictureLogic();
    if (Game.seenScenarios.includes(`V9VanessaMCBusNight`)) {
        ImageClass.setImage(images.v9.V9Night2);

    } else {

        ImageClass.setImage(images.v9.V9Morning);
    }

    if (!Game.seenScenarios.includes(`V9MorningTextsDay1`)) {
        return jump(V9MorningTextsDay1Before, "V9MorningTextsDay1Before");
    }

    await UI.add({
        key: "v9events",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Continue", key: "continue" }
            ]
    });
    if (UI._globalUI.v9events === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v9events === "continue") {

        if (!Game.seenScenarios.includes(`V9AnnMorningCallBefore`)) {
            return jump(V9AnnMorningCallBefore, "V9AnnMorningCallBefore");
        }


        if (isAnnGF()) {
            if (!Game.seenScenarios.includes(`V9AnnMCNightConvBefore`)) {

                return jump(V9AnnMCNightConvBefore, "V9AnnMCNightConvBefore");
            }
        } else {
            mc.talk(`TODO: ANN HATE -> DO EVENT OR CONTINUE WITHOUT THAT`);
        }





        return jump(V9EndDay1, "V9EndDay1");

    }

    return jump(V9Events, "V9Events");
};


export const V9AnnMorningCallBefore = async (): Promise<any> => {
    return jump(V9AnnMorningCall, "V9AnnMorningCall");
};
export const V9AnnMorningCallAfter = async (): Promise<any> => {
    return jump(V9EmilyMorningPlayingBefore, "V9EmilyMorningPlayingBefore");
};

export const V9EmilyMorningPlayingBefore = async (): Promise<any> => {

    return jump(V9EmilyMorningPlaying, "V9EmilyMorningPlaying");
};
export const V9EmilyMorningPlayingAfter = async (): Promise<any> => {
    return jump(V9VanessaBusBefore, "V9VanessaBusBefore");
};

export const V9VanessaBusBefore = async (): Promise<any> => {
    return jump(V9VanessaBus, "V9VanessaBus");
};
export const V9VanessaBusAfter = async (): Promise<any> => {
    return jump(V9VanessaMCChrisBarBefore, "V9VanessaMCChrisBarBefore");
};

export const V9VanessaMCChrisBarBefore = async (): Promise<any> => {
    return jump(V9VanessaMCChrisBar, "V9VanessaMCChrisBar");
};
export const V9VanessaMCChrisBarAfter = async (): Promise<any> => {
    return jump(V9VanessaMCBusNightBefore, "V9VanessaMCBusNightBefore");
};
export const V9VanessaMCBusNightBefore = async (): Promise<any> => {
    return jump(V9VanessaMCBusNight, "V9VanessaMCBusNight");
};
export const V9VanessaMCBusNightAfter = async (): Promise<any> => {
    return jump(V9Events, "V9Events");
};
export const V9AnnMCNightConvBefore = async (): Promise<any> => {
    return jump(V9AnnMCNightConv, "V9AnnMCNightConv");
};
export const V9AnnMCNightConvAfter = async (): Promise<any> => {
    if (shouldShowAnnChrisDormScene()) {
        return jump(V9AnnDormNightChrisBefore, "V9AnnDormNightChrisBefore");
    }
    return jump(V9EndDay1, "V9EndDay1");
};
export const V9AnnDormNightChrisBefore = async (): Promise<any> => {
    return jump(V9AnnDormNightChris, "V9AnnDormNightChris");
};
export const V9AnnDormNightChrisAfter = async (): Promise<any> => {
    return jump(V9EndDay1, "V9EndDay1");
};

export const V9EndDay1 = async (): Promise<any> => {
    await AnnProfilePictureLogic();
    if (Question.globalAnswers.v8EmilyKitchenNightJoinHerBed) {
        doTransition(images.v9.V9Night2);
        await mc.setQuestion(new Question({ text: `It's late... Better get some sleep.`, options: { think: true }, key: `v9EndDay1JoinedEmilyBed` })
            .option({ title: `Sleep with Emily`, key: true })
            .option({ title: `Sleep alone in your room`, key: false }));

        if (isAnnGFAndCorrupted()) {
            doSmsSound();
            await Phone.showMessagesUI({ name: ann.name }, async () => {
                if (Question.globalAnswers.v9AnnCorNightAskForHandjob) {
                    Phone.setMessage({ character: ann.character, text: `Sorry that I had to go tonight! I hope you are not mad 😘`, options: { wait: false } });
                } else {
                    Phone.setMessage({ character: ann.character, text: `I'm sorry that I didn't have more time tonight! 😔`, options: { wait: false } });
                    Phone.setMessage({ character: ann.character, text: `I promise that I'll make it up to you! 😜😜😜`, options: { wait: false } });
                }
                Phone.setImage({ ...images.v9.V9Ann1, character: ann.character, options: { wait: false } });

                Phone.setMessage({ character: ann.character, text: `Good night 👄`, options: { wait: false } });
                Phone.setMessage({ character: mc.character, text: `🍆` });
                Phone.closeMessagesUI();
            });

        }



        if (Question.globalAnswers.v9EndDay1JoinedEmilyBed) {
            mc.think(`I know Emily would appreciate if I sleep with her.`);
            doWaitImageByTime(images.v9.V9EmilyNightSleep_2);
            mc.think(`She is in bed already.`);
            doWaitImageByTime(images.v9.V9EmilyNightSleep_7);
            mc.think(`Slowly...`);
            doWaitImageByTime(images.v9.V9EmilyNightSleep_4);
            mc.think(`Damn... She is so hot...`);
            doWaitImageByTime(images.v9.V9EmilyNightSleep_3);
            mc.think(`Slowly...`);
            doWaitImageByTime(images.v9.V9EmilyNightSleep_5);
            mc.think(`Time to sleep...`);

        } else {

            doWaitImageByTime(images.v5.Room2_2);
            mc.think(`Time to sleep.`);
        }

    } else {
        doTransition(images.v5.Room2_2);

    }

    return jump(V9EndDay2Morning, "V9EndDay2Morning");
};

export const V9EndDay2Morning = async (): Promise<any> => {
    if (!Game.seenScenarios.includes(`V9EndDay2Morning`)) {
        if (Question.globalAnswers.v9EndDay1JoinedEmilyBed) {
            doWaitImageByTime(images.v9.V9EmilyNightSleep_6, null, 2);
            mc.think(`Morning.`);

        } else {
            doWaitImageByTime(images.v1.Room2, null, 2);
            mc.think(`Morning.`);
        }

        if (isDatingJenny()) {
            await doSmsSound();
            await Phone.showMessagesUI({ name: jenny.name }, async () => {
                Phone.setMessage({ character: jenny.character, text: `Good morning 😘`, options: { wait: false } });
                Phone.setMessage({ character: mc.character, text: `Morning beautiful.` });
                Phone.setMessage({ character: jenny.character, text: `I bought something really interesting yesterday...` });
                Phone.setMessage({ character: mc.character, text: `Show me!` });
                Phone.setImage({ ...images.v9.V9Jenny1, character: jenny.character, options: { wait: true } });
                Phone.setMessage({ character: jenny.character, text: `What do you think? 😜` });
                Phone.setMessage({ character: mc.character, text: `Perfection!` });
                Phone.setMessage({ character: jenny.character, text: `I'm going to wear it next time I see you 😏` });
                Phone.setMessage({ character: mc.character, text: `Are you busy right now? 😲` });
                Phone.setMessage({ character: jenny.character, text: `Haha! unfortunately yes.` });
                Phone.setMessage({ character: mc.character, text: `And now?` });
                Phone.setMessage({ character: jenny.character, text: `LOL` });
                Phone.setMessage({ character: mc.character, text: `Fuck! So it has to be real soon!` });
                Phone.setMessage({ character: jenny.character, text: `😘` });
                Phone.closeMessagesUI();
            });
            if (Question.globalAnswers.v8JennyDateTouchedBreasts) {
                mc.think(`Damn! It seems like I'm going to get more than a boob grab next time!`);

            } else if (Question.globalAnswers.v7JennyDateTriedToGoFurther) {
                mc.think(`Damn! It seems like I'm going to get more than a leg grab next time!`);
            } else {
                mc.think(`Damn! My patience paid off! It seems like I'm going to get some real action next time!`);

            }

        } else {
            doTransition(images.v1.Room2, null, 2);

        }
        if (Question.globalAnswers.v9EndDay1JoinedEmilyBed) {
            mc.think(`When did Emily leave bed anyway? I slept like a rock.`);

        }
        // doWaitImageByTime(images.v9.V9Morning);
    }


    // Do I really need to put a UI here? If I'll have an interesting Insta from Ann and Alex yes... right now it's no
    // await UI.add({
    //     key: "v9Day2Morning",
    //     btns:
    //         [
    //             { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
    //             { image: uiImages.continue, tooltip: "Continue", key: "continue" }
    //         ]
    // });
    // if (UI._globalUI.v9Day2Morning === "insta") {
    //     // TODO: add insta photos
    //     await Insta.open(getInstaData());
    // }
    // if (UI._globalUI.v9Day2Morning === "continue") {
    //     return jump(V9EmilyMorningDay2Before, "V9EmilyMorningDay2Before");


    // }
    return jump(V9EmilyMorningDay2Before, "V9EmilyMorningDay2Before");

    // return jump(V9EndDay2Morning, "V9EndDay2Morning");

};

export const V9EmilyMorningDay2Before = async (): Promise<any> => {
    return jump(V9EmilyMorningDay2, "V9EmilyMorningDay2");
};
export const V9EmilyMorningDay2After = async (): Promise<any> => {
    // TODO: alpha -> missing scene here
    return jump(V9AlexDateBefore, "V9AlexDateBefore");
};

export const V9AlexDateBefore = async (): Promise<any> => {
    return jump(V9AlexDate, "V9AlexDate");
};
export const V9AlexDateAfter = async (): Promise<any> => {
    return jump(V9EndDay2, "V9EndDay2");
};

export const V9EndDay2 = async (): Promise<any> => {

    if (!Game.seenScenarios.includes(`V9EndDay2`)) {
        doTransition(images.v9.V9MCRoomAfterAlexDate_2);
        if (Question.globalAnswers.v9AlexDateAfterJoinedHerWater) {
            mc.think(`Wow... That was more intense then I thought it would.`);
            mc.think(`Alex is certainly something else...`);
            if (isAnnGF()) {
                mc.think(`I wonder what Ann would say about that once she hears the details...`);
            }

        } else {
            mc.think(`That went well. I did a pretty good job.`);
            if (isAnnGF()) {
                mc.think(`I did it for Ann. I hope she'll appreciate it.`);
                mc.think(`One thing I can say for sure. I'm exhausted...\nBetter get some sleep.`);
            }
        }

        // TODO: alpha, other message for not corrupted after the alpha
        // if (isAnnGFAndCorrupted()) {
        //     await doSmsSound();
        //     mc.think(`A text from Ann.`);
        //     mc.think(`Did she talk to Alex already?`);
        //     await Phone.showMessagesUI({ name: ann.name }, async () => {
        //         Phone.setMessage({ character: ann.character, text: `I just want to tell you that I love you and wish you good night 😘`, options: { wait: false } });
        //         Phone.setImage({ ...images., character: .character, options: { wait: false } });
        //         // Phone.talk({ character: .character, text: `` });

        //         Phone.closeMessagesUI();
        //     });

        // }



    }

    await UI.add({
        key: "v9EndDay2",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Continue", key: "continue" }
            ]
    });
    if (UI._globalUI.v9EndDay2 === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v9EndDay2 === "continue") {
        if (Question.globalAnswers.v9EndDay1JoinedEmilyBed) {
            return jump(V9EmilyNightDayTwoBefore, "V9EmilyNightDayTwoBefore");
        }
        return jump(V9Day3Morning, "V9Day3Morning");
    }


    return jump(V9EndDay2, "V9EndDay2");
};
export const V9EmilyNightDayTwoBefore = async (): Promise<any> => {
    return jump(V9EmilyNightDayTwo, "V9EmilyNightDayTwo");
};
export const V9EmilyNightDayTwoAfter = async (): Promise<any> => {
    return jump(V9Day3Morning, "V9Day3Morning");
};

export const V9Day3Morning = async (): Promise<any> => {
    return jump(V9EmilyMorningRoomDay3Before, "V9EmilyMorningRoomDay3Before");
};

export const V9EmilyMorningRoomDay3Before = async (): Promise<any> => {
    return jump(V9EmilyMorningRoomDay3, "V9EmilyMorningRoomDay3");
};
export const V9EmilyMorningRoomDay3After = async (): Promise<any> => {
    if (isAnnGF() && !isAnnCorrupted()) {
        doTransition(images.v9.V9MorningInstaAlex);
        await doSmsSound();
        mc.think(`It's Ann.`);
        if (mc.properties.v9HadSexWithChrisBehindMCBack) {
            mc.think(`Is she going to mention the fact that she fucked Chris after I clearly asked her not to?`);
            if (Question.globalAnswers.v9AnnDormNightChrisMasturbated) {
                mc.think(`Not that I'm complaining... I got a front row sits to the best show in town.`);
            } else {

                mc.think(`In any case. I better keep it cool before I'll have a chance to talk to her and let her explain herself.`);
                mc.think(`Not that there is anything to explain. I saw everything.`);
            }
        }
        await Phone.showMessagesUI({ name: ann.name }, async () => {
            Phone.setMessage({ character: ann.character, text: `Heyyyy guess what??? 😀`, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `What?` });
            Phone.setMessage({ character: ann.character, text: `I can come home for a few days! 🥳` });
            Phone.setMessage({ character: mc.character, text: `That's great! When?` });
            Phone.setMessage({ character: ann.character, text: `I'm not sure... I need to check the flights schedules.` });
            Phone.setMessage({ character: ann.character, text: `I know things are kinda hectic here right now. But I'll do my best!` });
            Phone.setMessage({ character: mc.character, text: `What if I'll drive there and come to pick you up?` });
            Phone.setMessage({ character: ann.character, text: `You'll do that? 🫨` });
            Phone.setMessage({ character: mc.character, text: `Only if you want me to.` });
            Phone.setMessage({ character: ann.character, text: `Of course! I'd love to! 💓` });
            Phone.setMessage({ character: mc.character, text: `Alright, so I'll get going right away!` });
            Phone.setMessage({ character: ann.character, text: `👄👄👄` });
            Phone.closeMessagesUI();
        });
        if (isAnnGF() && !isAnnCorrupted()) {
            if (Question.globalAnswers.v9AnnDormNightChrisKeepWatching1 !== undefined) {
                mc.think(`Chris couldn't get her tickets to fly back with him?`);
                mc.think(`Maybe she just didn't tell him.`);
                mc.think(`Or could be he doesn't even care...`);

            }
            await globals.set((properties) => {
                properties.playedVersion === "0.9a";
            });
            Game.showEnding("alpha");
        }
    }

    return jump(V9AnnMCMotelBefore, "V9AnnMCMotelBefore");
};

export const V9AnnMCMotelBefore = async (): Promise<any> => {
    return jump(V9AnnMCMotel, "V9AnnMCMotel");
};
export const V9AnnMCMotelAfter = async (): Promise<any> => {
};
